import * as yup from 'yup';

import {
  validateGiftRecipient,
  validateRecipientEmail,
} from '../../../utils/backend-api/groupSubscription';

export default function validateSubscriptionEmail() {
  return yup
    .string()
    .test('email validation', 'Please enter valid email address', async (email) => {
      const res = await validateRecipientEmail(email);
      if (!res.success) {
        return false;
      }

      return true;
    })
    .test('validate', 'User is already a subscriber', async (email) => {
      const res = await validateGiftRecipient({
        email: email,
      });
      if (!res.success) {
        return false;
      }

      return true;
    })
    .required('Email address is required');
}
